import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import DashboardDiario from '../components/Gestor/DashboardDiario';
import HistoricoVisitas from '../components/Gestor/HistoricoVisitas';
import ResumoGeral from '../components/Gestor/ResumoGeral';
import GerenciarSupervisores from '../components/Gestor/GerenciarSupervisores';
import AuditoriaLog from '../components/Gestor/AuditoriaLog';
import GerenciarLocalidades from '../components/Gestor/GerenciarLocalidades';
import GerenciarUsuarios from '../components/Gestor/GerenciarUsuarios';
import './Dashboard.css';
function GestorDashboard({ user }) {
  const [activeView, setActiveView] = useState('diario');

  return (
    <div>
      <Navbar user={user} />
      <div className="dashboard-container">
        <div className="view-switcher">
          <button onClick={() => setActiveView('diario')} className={activeView === 'diario' ? 'active' : ''}>Painel Diário</button>
          <button onClick={() => setActiveView('resumo')} className={activeView === 'resumo' ? 'active' : ''}>Resumo Geral</button>
          <button onClick={() => setActiveView('historico')} className={activeView === 'historico' ? 'active' : ''}>Histórico de Visitas</button>
          <button onClick={() => setActiveView('supervisores')} className={activeView === 'supervisores' ? 'active' : ''}>Supervisores</button>
          <button onClick={() => setActiveView('localidades')} className={activeView === 'localidades' ? 'active' : ''}>🗺️ Localidades</button>
          <button onClick={() => setActiveView('usuarios')} className={activeView === 'usuarios' ? 'active' : ''}>👥 Usuários</button>
          {/* Aba visível apenas para Gestor e Master */}
          <button onClick={() => setActiveView('auditoria')} className={activeView === 'auditoria' ? 'active' : ''}>📋 Auditoria</button>
        </div>

        <div className="view-content">
          {activeView === 'diario' && <DashboardDiario user={user} />}
          {activeView === 'resumo' && <ResumoGeral user={user} />}
          {activeView === 'historico' && <HistoricoVisitas user={user} />}
          {activeView === 'supervisores' && <GerenciarSupervisores user={user} />}
          {activeView === 'localidades' && <GerenciarLocalidades user={user} />}
          {activeView === 'usuarios' && <GerenciarUsuarios user={user} />}
          {activeView === 'auditoria' && <AuditoriaLog user={user} />}
        </div>
      </div>
    </div>
  );
}

export default GestorDashboard;